(() => {
  'use strict';
  const dialog = document.getElementById('bpf-lc-light-upsell');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const root = dialog.dataset.root || '/';
  const ids = { front: 44064393691421, rear: 45211192852765, bundle: 67915002577181 };
  const handles = ['land-cruiser-80-series-front-rear-light-bracket-kit-1993-1997', 'bpf-80-series-land-cruiser-and-lx450-mirror-light-brackets', 'bpf-80-series-land-cruiser-rear-light-brackets-92-97'];
  const accept = dialog.querySelector('[data-bpf-accept]');
  const status = dialog.querySelector('[data-bpf-status]');
  const label = accept.textContent;
  let sourceKey = null;
  let busy = false;
  let checking = false;
  let productsPromise;
  let returnFocus;
  const preview = dialog.dataset.previewAllowed === 'true' && new URLSearchParams(location.search).get('bpf_lc_bundle_preview') === '1';
  const request = async (path, body) => {
    const response = await fetch(root + path, {
      credentials: 'same-origin',
      cache: 'no-store',
      ...(body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || 'Request failed');
    return data;
  };
  const eligible = cart => {
    if (cart.items.some(item => item.variant_id === ids.bundle)) return null;
    const singles = cart.items.filter(item => item.variant_id === ids.front || item.variant_id === ids.rear);
    return singles.length === 1 && singles[0].quantity === 1 ? singles[0] : null;
  };
  const getProducts = () => {
    if (!productsPromise) productsPromise = Promise.all(handles.map(handle => request('products/' + handle + '.js'))).catch(error => { productsPromise = null; throw error; });
    return productsPromise;
  };
  const display = (products, currency) => {
    const [bundle, front, rear] = products;
    const variant = bundle.variants.find(item => item.id === ids.bundle);
    const frontVariant = front.variants.find(item => item.id === ids.front);
    const rearVariant = rear.variants.find(item => item.id === ids.rear);
    if (!variant || !frontVariant || !rearVariant || !variant.available) return false;
    const original = frontVariant.price + rearVariant.price;
    if (variant.price >= original) return false;
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
    dialog.querySelector('[data-bpf-original]').textContent = money(original);
    dialog.querySelector('[data-bpf-price]').textContent = money(variant.price) + ' ' + currency;
    const saving = dialog.querySelector('[data-bpf-saving]');
    saving.textContent = saving.dataset.template.replace('[amount]', money(original - variant.price));
    const image = dialog.querySelector('[data-bpf-image]');
    if (bundle.featured_image) { image.src = bundle.featured_image; image.hidden = false; }
    status.textContent = '';
    returnFocus = document.activeElement;
    dialog.showModal();
    accept.focus();
    return true;
  };
  const refresh = () => document.dispatchEvent(new CustomEvent('cart:build'));
  const finish = () => { refresh(); dialog.close(); };
  const dismiss = () => { if (!busy) dialog.close(); };
  dialog.querySelectorAll('[data-bpf-dismiss]').forEach(button => button.addEventListener('click', dismiss));
  dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog || busy) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dismiss();
  });
  dialog.addEventListener('close', () => { if (returnFocus?.isConnected) returnFocus.focus(); });
  const check = async event => {
    if (preview || checking || busy || dialog.open || document.querySelector('dialog[open].bpf-upsell')) return;
    const added = event?.detail?.product;
    if (added && ![ids.front, ids.rear].includes(Number(added.variant_id || added.id))) return;
    checking = true;
    dialog.dataset.check = 'reading-cart';
    try {
      const cart = await request('cart.js');
      const single = eligible(cart);
      if (!single) { dialog.dataset.check = 'ineligible'; return; }
      dialog.dataset.check = 'loading-products';
      const products = await getProducts();
      sourceKey = single.key;
      dialog.dataset.check = display(products, cart.currency) ? 'shown' : 'unavailable';
    } catch (error) {
      sourceKey = null;
      dialog.dataset.check = 'error';
      console.warn('BPF Land Cruiser light offer:', error.message);
    } finally { checking = false; }
  };
  accept.addEventListener('click', async () => {
    if (busy || preview || !sourceKey) return;
    busy = true;
    accept.disabled = true;
    accept.textContent = accept.dataset.loading;
    status.textContent = '';
    let attemptedAdd = false;
    let attemptedRemove = false;
    try {
      const before = await request('cart.js');
      const single = eligible(before);
      if (!single || single.key !== sourceKey) { status.textContent = status.dataset.changed; return; }
      attemptedAdd = true;
      await request('cart/add.js', { items: [{ id: ids.bundle, quantity: 1 }] });
      attemptedRemove = true;
      await request('cart/change.js', { id: sourceKey, quantity: 0 });
      const after = await request('cart.js');
      if (after.items.some(item => item.key === sourceKey) || !after.items.some(item => item.variant_id === ids.bundle && item.quantity === 1)) throw new Error('Cart did not match the offer');
      finish();
    } catch (error) {
      if (attemptedAdd) {
        try {
          const current = await request('cart.js');
          const single = current.items.find(item => item.key === sourceKey);
          const pair = current.items.find(item => item.variant_id === ids.bundle);
          if (attemptedRemove && !single && pair?.quantity === 1) { finish(); return; }
          if (single && pair?.quantity === 1) await request('cart/change.js', { id: pair.key, quantity: 0 });
        } catch (recoveryError) {
          location.assign(root + 'cart');
          return;
        }
      }
      refresh();
      status.textContent = status.dataset.error;
    } finally {
      busy = false;
      accept.disabled = false;
      accept.textContent = label;
    }
  });
  document.addEventListener('ajaxProduct:added', check);
  if (document.body.classList.contains('template-cart')) check();
  if (preview) {
    const products = [
      { variants: [{ id: ids.bundle, price: 16200, available: true }], featured_image: 'https://cdn.shopify.com/s/files/1/0183/4139/products/image_c5d1b872-a094-4608-8277-b5f0e5936ab7.jpg?v=1670307149' },
      { variants: [{ id: ids.front, price: 12000 }] },
      { variants: [{ id: ids.rear, price: 6000 }] }
    ];
    display(products, 'USD');
    accept.disabled = true;
    status.textContent = status.dataset.preview;
  }
})();
